import { ActionBase } from '../../../core/store/action/ActionBase';
import { LookupModel } from '../../../common/models/LookupModel';
import { ModuleConfiguration } from '../../datawarehouse.module.config';

export const SUBMITTING_ENTITY_SELECTED = `[${ModuleConfiguration.moduleName}] Submitting Entity Selected`;

export class SubmittingEntitySelectedAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = SUBMITTING_ENTITY_SELECTED;
  
  constructor(public payload: { submittingEntity: LookupModel; }) { }
}



// WEBPACK FOOTER //
// ./src/app/datawarehouse/store/actions/SubmittingEntitySelectedAction.ts